import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Popconfirm, Checkbox, Input, Switch,
} from 'antd';
import {
  DeleteOutlined, CheckOutlined, PlusCircleFilled, CloseCircleFilled, EditOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import Crown from '@Images/crown2.png';
import UserActions from '@Actions/userActions';
import vendorRatingActions from '../../../../actions/configurations/vendorRatingActions';

const VendorRatingConfig = ({
  user, updateVendorRatingSetting, updateVendorRatingSettingLoading, getVendorRating, getVendorRatingSuccess, getVendorRatingLoading, enableVendorRatingConfig, enableVendorRatingConfigLoading, getUserProfile,
}) => {
  const [enableVendorRating, setEnableVendorRating] = useState();
  const [titleData, setTitleData] = useState([]);
  const [reasonData, setReasonData] = useState([]);
  const [editingTitleIndex, setEditingTitleIndex] = useState(null);
  const [editingReasonIndex, setEditingReasonIndex] = useState(null);
  const [addingNewTitle, setAddingNewTitle] = useState(false);
  const [addingNewReason, setAddingNewReason] = useState(false);
  const [newTitleInput, setNewTitleInput] = useState('');
  const [newReasonInput, setNewReasonInput] = useState('');
  const [hoveredRowTitle, setHoveredRowTitle] = useState(null);
  const [hoveredRowReason, setHoveredRowReason] = useState(null);
  const [additionalRatingNames, setAdditionalRatingNames] = useState([]);
  const [enableAdditionalRatingStatus, setEnableAdditionalRatingStatus] = useState([]);

  const vendorRatingEnabled = user?.tenant_info?.global_config?.sub_modules?.vendor_rating?.is_active;

  const handleEnableVendorRating = (value) => {
    setEnableVendorRating(value);
    const payload = {
      entity_type: 'SELLER',
      is_active: value,

    };
    enableVendorRatingConfig(payload, () => {
      getVendorRating(user?.tenant_info?.org_id);
    });
  };

  useEffect(() => {
    getVendorRating(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    handleEnableVendorRating(vendorRatingEnabled);
  }, [user]);

  useEffect(() => {
    if (getVendorRatingSuccess) {
      setTitleData(getVendorRatingSuccess.custom_reasons || []);
      setReasonData(getVendorRatingSuccess.low_rating_reasons || []);
      setEnableVendorRating(getVendorRatingSuccess.is_active);
      setAdditionalRatingNames(
        getVendorRatingSuccess.name_mapping.map((item) => item.name),
      );
      setEnableAdditionalRatingStatus(
        getVendorRatingSuccess.name_mapping.map((item) => getVendorRatingSuccess[item.key]),
      );
    }
  }, [getVendorRatingSuccess]);

  const updateVendorRatingConfig = (updatedEnabledStatus, newTitleData, newReasonData) => {
    if (reasonData.length > 0 || titleData.length > 0) {
      const payload = {
        entity_type: 'SELLER',
        low_rating_reasons: newReasonData,
        custom_reasons: newTitleData,
        additional_rating_1: updatedEnabledStatus[0] || false,
        additional_rating_2: updatedEnabledStatus[1] || false,
        additional_rating_3: updatedEnabledStatus[2] || false,
      };
      updateVendorRatingSetting(payload, () => {
        getVendorRating(user?.tenant_info?.org_id);
      });
    }
  };

  const isAddTitleDisabled = titleData.length >= 5;
  const isAddReasonDisabled = reasonData.length >= 5;
  return (
    <Fragment>
      <Checkbox
        style={{ marginRight: '10px' }}
        checked={enableVendorRating}
        onChange={(e) => handleEnableVendorRating(e.target.checked)}
        disabled={!vendorRatingEnabled}
      />
      <span
        style={{
          fontSize: '14px',
        }}
      >
        Enable Vendor Rating
      </span>
      &nbsp;
      {!vendorRatingEnabled && (
        <Popconfirm
          placement="topRight"
          title="This feature is not available in your current plan"
          onConfirm={() => window.Intercom('showNewMessage')}
          okText="Contact Us"
          cancelText="Cancel"
        >
          <img className="barcode-restrict" src={Crown} alt="premium" />
        </Popconfirm>
      )}

      {enableVendorRating ? (
        <Fragment>
          {/* additional_rating */}
          {/* <div className="vendor-rating-config__wrapper"> */}
          {/*  <div className="ant-row"> */}
          {/*    <div className="ant-col-md-18"> */}
          {/*      <div className="vendor-rating-config__table__wrapper"> */}
          {/*        <div className="vendor-rating-config__table__data hide__in-mobile"> */}
          {/*          <Table */}
          {/*            loading={updateVendorRatingSettingLoading || getVendorRatingLoading || enableVendorRatingConfigLoading} */}
          {/*            pagination={false} */}
          {/*            showHeader */}
          {/*            size="small" */}
          {/*            columns={[ */}
          {/*              { */}
          {/*                render: (text, record) => ( */}
          {/*                  <span>{record}</span> */}
          {/*                ), */}
          {/*              }, */}
          {/*              { */}
          {/*                key: 'enabled', */}
          {/*                fixed: 'left', */}
          {/*                width: 100, */}
          {/*                render: (text, record, index) => ( */}
          {/*                  <div style={{ */}
          {/*                    textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', */}
          {/*                  }} */}
          {/*                  > */}
          {/*                    <Switch */}
          {/*                      checked={enableAdditionalRatingStatus[index]} */}
          {/*                      onChange={(checked) => { */}
          {/*                        const updatedEnabledStatus = [...enableAdditionalRatingStatus]; */}
          {/*                        updatedEnabledStatus[index] = checked; */}
          {/*                        setEnableAdditionalRatingStatus(updatedEnabledStatus); */}
          {/*                        updateVendorRatingConfig( */}
          {/*                          updatedEnabledStatus, */}
          {/*                          titleData, */}
          {/*                          reasonData, */}
          {/*                        ); */}
          {/*                      }} */}
          {/*                      loading={updateVendorRatingSettingLoading || getVendorRatingLoading || enableVendorRatingConfigLoading} */}
          {/*                      size="small" */}
          {/*                      style={{ */}
          {/*                        paddingTop: '10px', */}
          {/*                        paddingBottom: '5px', */}
          {/*                      }} */}
          {/*                    /> */}
          {/*                  </div> */}
          {/*                ), */}
          {/*              }, */}
          {/*            ]} */}
          {/*            dataSource={additionalRatingNames || []} */}
          {/*          /> */}
          {/*        </div> */}
          {/*      </div> */}
          {/*    </div> */}
          {/*  </div> */}
          {/* </div> */}
          {/* Custom rating titles */}
          {/* <div className="vendor-rating-config__wrapper"> */}
          {/*  <div className="ant-row"> */}
          {/*    <div className="ant-col-md-18"> */}
          {/*      <div className="vendor-rating-config__table__wrapper"> */}
          {/*        <div className="vendor-rating-config__table__data hide__in-mobile"> */}
          {/*          <Table */}
          {/*            title={() => ( */}
          {/*              <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
          {/*                <H3Text text={`${titleData.length} ${'Custom Rating Title(s)'}`} className="title" /> */}
          {/*              </div> */}
          {/*            )} */}
          {/*            loading={updateVendorRatingSettingLoading || getVendorRatingLoading || enableVendorRatingConfigLoading} */}
          {/*            pagination={false} */}
          {/*            showHeader */}
          {/*            size="small" */}
          {/*            columns={[ */}
          {/*              { */}
          {/*                render: (text, record, index) => ( */}
          {/*                  <div */}
          {/*                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} */}
          {/*                    onMouseEnter={() => setHoveredRowTitle(index)} */}
          {/*                    onMouseLeave={() => setHoveredRowTitle(null)} */}
          {/*                    onClick={() => setEditingTitleIndex(index)} */}
          {/*                  > */}

          {/*                    <React.Fragment> */}
          {/*                      {editingTitleIndex === index ? ( */}
          {/*                        <Input */}
          {/*                          value={titleData[index]} */}
          {/*                          onChange={(e) => { */}
          {/*                            const updatedTitleData = [...titleData]; */}
          {/*                            updatedTitleData[index] = e.target.value; */}
          {/*                            setTitleData(updatedTitleData); */}
          {/*                          }} */}
          {/*                          onBlur={() => { */}
          {/*                            setEditingTitleIndex(null); */}
          {/*                            updateVendorRatingConfig(enableAdditionalRatingStatus, titleData, reasonData); */}
          {/*                          }} */}
          {/*                          style={{ width: '100%' }} */}
          {/*                        /> */}
          {/*                      ) : ( */}
          {/*                        <div> */}
          {/*                          <span>{record}</span> */}
          {/*                          {hoveredRowTitle === index && ( */}
          {/*                            <EditOutlined */}
          {/*                              style={{ marginLeft: '8px', fontSize: '16px', color: 'rgb(65, 150, 255)' }} */}

          {/*                            /> */}
          {/*                          )} */}
          {/*                        </div> */}

          {/*                      )} */}

          {/*                    </React.Fragment> */}

          {/*                  </div> */}
          {/*                ), */}
          {/*              }, */}
          {/*              { */}
          {/*                title: '', */}
          {/*                key: 'action', */}
          {/*                fixed: 'left', */}
          {/*                width: 100, */}
          {/*                render: (text, record, index) => ( */}
          {/*                  <div style={{ */}
          {/*                    textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', */}
          {/*                  }} */}
          {/*                  > */}
          {/*                    {editingTitleIndex === index ? ( */}
          {/*                      <div */}
          {/*                        className="roundIconButton" */}
          {/*                        onClick={() => setEditingTitleIndex(null)} */}
          {/*                      > */}
          {/*                        <CheckOutlined /> */}
          {/*                      </div> */}
          {/*                    ) : ( */}
          {/*                      <Popconfirm */}
          {/*                        placement="topRight" */}
          {/*                        title="Are you sure you want to delete this Title?" */}
          {/*                        onConfirm={() => { */}
          {/*                          const updatedTitleData = titleData.filter((_, i) => i !== index); */}
          {/*                          setTitleData(updatedTitleData); */}
          {/*                          updateVendorRatingConfig(enableAdditionalRatingStatus, updatedTitleData, reasonData); */}
          {/*                        }} */}
          {/*                        okText="Yes" */}
          {/*                        cancelText="No" */}
          {/*                      > */}
          {/*                        <div */}
          {/*                          className="deleteButton" */}
          {/*                        > */}
          {/*                          <DeleteOutlined /> */}
          {/*                        </div> */}
          {/*                      </Popconfirm> */}
          {/*                    )} */}
          {/*                  </div> */}
          {/*                ), */}
          {/*              }, */}
          {/*            ]} */}
          {/*            dataSource={titleData || []} */}
          {/*          /> */}
          {/*          {addingNewTitle && ( */}
          {/*            <div */}
          {/*              className="ant-row " */}
          {/*            > */}
          {/*              <Input */}
          {/*                placeholder="Enter New Title" */}
          {/*                value={newTitleInput} */}
          {/*                onChange={(e) => setNewTitleInput(e.target.value)} */}
          {/*                style={{ width: '85%', marginRight: '23px' }} */}
          {/*              /> */}
          {/*              <span */}
          {/*                className="roundIconButton" */}
          {/*                onClick={() => { */}
          {/*                  if (newTitleInput.trim() !== '' && titleData.length < 5) { */}
          {/*                    const updatedTitleData = [...titleData, newTitleInput]; */}
          {/*                    setTitleData(updatedTitleData); */}
          {/*                    setNewTitleInput(''); */}
          {/*                    setAddingNewTitle(false); */}
          {/*                    updateVendorRatingConfig(enableAdditionalRatingStatus, updatedTitleData, reasonData); */}
          {/*                  } */}
          {/*                }} */}
          {/*              > */}
          {/*                <CheckOutlined style={{ fontSize: 'medium' }} /> */}
          {/*              </span> */}
          {/*              <span */}
          {/*                onClick={(e) => { */}
          {/*                  e.stopPropagation(); */}
          {/*                  setNewTitleInput(''); */}
          {/*                  setAddingNewTitle(false); */}
          {/*                }} */}
          {/*              > */}
          {/*                <CloseCircleFilled style={{ */}
          {/*                  color: 'red', fontSize: 'medium', paddingTop: '5px', cursor: 'pointer', */}
          {/*                }} */}
          {/*                /> */}
          {/*              </span> */}
          {/*            </div> */}
          {/*          )} */}
          {/*        </div> */}
          {/*      </div> */}
          {/*    </div> */}
          {/*  </div> */}
          {/* </div> */}

          {/* Adding new row for Custom Title */}
          <div
            onClick={() => {
              if (!isAddTitleDisabled) {
                if (addingNewTitle) {
                  setAddingNewTitle(false);
                } else {
                  setAddingNewTitle(true);
                }
              }
            }}
          >
            {/* <div */}
            {/*  className="new-row-button" */}
            {/*  style={{ */}
            {/*    marginBottom: '10px', padding: '0px', marginTop: '0px', width: '95px', */}
            {/*  }} */}
            {/* > */}
            {/*  <span */}
            {/*    className="new-row-button__icon" */}
            {/*    style={{ cursor: isAddTitleDisabled ? 'not-allowed' : 'pointer' }} */}
            {/*  > */}
            {/*    <PlusCircleFilled /> */}
            {/*  </span> */}
            {/*  <div style={{ cursor: isAddTitleDisabled ? 'not-allowed' : 'pointer' }}> */}
            {/*    New Title */}
            {/*  </div> */}
            {/* </div> */}

          </div>

          {/* Low rating reasons */}
          <div className="vendor-rating-config__wrapper">
            <div className="ant-row">
              <div className="ant-col-md-18">
                <div className="vendor-rating-config__table__wrapper">
                  <div className="vendor-rating-config__table__data hide__in-mobile">
                    <Table
                      title={() => (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <H3Text text={`${reasonData.length} ${'Low Rating Reason(s)'}`} className="title" />
                        </div>
                      )}
                      loading={updateVendorRatingSettingLoading || getVendorRatingLoading || enableVendorRatingConfigLoading}
                      pagination={false}
                      showHeader={false}
                      size="small"
                      columns={[
                        {
                          render: (text, record, index) => (
                            <div
                              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                              onMouseEnter={() => setHoveredRowReason(index)}
                              onMouseLeave={() => setHoveredRowReason(null)}
                              onClick={() => setEditingReasonIndex(index)}
                            >
                              <div className="low-rating__input">
                                {editingReasonIndex === index ? (
                                  <Input
                                    value={reasonData[index]}
                                    onChange={(e) => {
                                      const updatedReasonData = [...reasonData];
                                      updatedReasonData[index] = e.target.value;
                                      setReasonData(updatedReasonData);
                                    }}
                                    onBlur={() => {
                                      // const filteredReasonData = reasonData.filter((reason) => reason.trim() !== ''); // Filter out empty strings
                                      if (!reasonData.includes('')) {
                                        setEditingReasonIndex(null);
                                        updateVendorRatingConfig(enableAdditionalRatingStatus, titleData, reasonData);
                                      }
                                    }}
                                    style={{ width: '100%' }}
                                  />
                                ) : (
                                  <div>
                                    <span>{record}</span>
                                    {hoveredRowReason === index && (
                                      <EditOutlined
                                        style={{ marginLeft: '8px', fontSize: '16px', color: 'rgb(65, 150, 255)' }}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          ),
                        },
                        {
                          title: '',
                          key: 'action',
                          fixed: 'left',
                          width: 100,
                          render: (text, record, index) => (
                            <div style={{
                              textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
                            }}
                            >
                              {editingReasonIndex === index ? (
                                <div
                                  className="roundIconButton"
                                // onClick={() => {
                                //   if (!reasonData.includes('')) {
                                //     setEditingReasonIndex(null);
                                //   }
                                // }}
                                >
                                  <CheckOutlined />
                                </div>
                              ) : (
                                <Popconfirm
                                  placement="topRight"
                                  title="Are you sure you want to delete this Reason?"
                                  onConfirm={() => {
                                    const updatedReasonData = reasonData.filter((_, i) => i !== index);
                                    setReasonData(updatedReasonData);
                                    updateVendorRatingConfig(enableAdditionalRatingStatus, titleData, updatedReasonData);
                                  }}
                                  okText="Yes"
                                  cancelText="No"
                                >
                                  <div
                                    className="deleteButton"
                                  >
                                    <DeleteOutlined />
                                  </div>
                                </Popconfirm>
                              )}
                            </div>
                          ),
                        },
                      ]}
                      dataSource={reasonData || []}
                    />
                    {addingNewReason && (
                      <div
                        className="ant-row fixed-row"
                      >
                        <Input
                          placeholder="Enter New Reason"
                          value={newReasonInput}
                          onChange={(e) => setNewReasonInput(e.target.value)}
                          style={{ width: '85%', marginRight: '22px' }}
                        />
                        <div
                          className="roundIconButton"
                          onClick={() => {
                            if (newReasonInput.trim() !== '' && reasonData.length < 5) {
                              const updatedReasonData = [...reasonData, newReasonInput];
                              setReasonData(updatedReasonData);
                              setNewReasonInput('');
                              setAddingNewReason(false);
                              updateVendorRatingConfig(enableAdditionalRatingStatus, titleData, updatedReasonData);
                            }
                          }}
                        >
                          <CheckOutlined style={{ fontSize: 'medium' }} />
                        </div>

                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setNewReasonInput('');
                            setAddingNewReason(false);
                          }}
                        >
                          <CloseCircleFilled style={{
                            color: 'red', fontSize: 'medium', paddingTop: '5px', cursor: 'pointer',
                          }}
                          />
                        </span>

                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() => !isAddReasonDisabled && setAddingNewReason(true)}
            className="new-row-button"
            style={{
              marginBottom: '10px', marginTop: '0px', width: '118px', padding: '15px',
            }}
          >
            <span
              className="new-row-button__icon"
              style={{ cursor: isAddReasonDisabled ? 'not-allowed' : 'pointer' }}
            >
              <PlusCircleFilled />
            </span>
            <div style={{ cursor: isAddReasonDisabled ? 'not-allowed' : 'pointer' }}>
              New Reason
            </div>
          </div>

        </Fragment>
      ) : (
        <div>
          <p
            style={{
              marginTop: '10px',
              fontSize: '14px',
            }}
          >
            {vendorRatingEnabled ? 'Vendor rating is currently disabled. Please enable it to configure custom titles and reasons.' : ''}

          </p>
        </div>
      )}

    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, VendorRatingReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  getVendorRatingLoading: VendorRatingReducers.getVendorRatingLoading,
  getVendorRatingSuccess: VendorRatingReducers.getVendorRatingSuccess,
  enableVendorRatingConfigLoading: VendorRatingReducers.enableVendorRatingConfigLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateVendorRatingSetting: (payload, callback) => dispatch(vendorRatingActions.updateVendorRatingSetting(payload, callback)),
  getVendorRating: (orgId, callback) => dispatch(vendorRatingActions.getVendorRating(orgId, callback)),
  enableVendorRatingConfig: (orgId, callback) => dispatch(vendorRatingActions.enableVendorRatingConfig(orgId, callback)),
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),
});

VendorRatingConfig.propTypes = {
  user: PropTypes.any,
  updateVendorRatingSettingLoading: PropTypes.any,
  updateVendorRatingSetting: PropTypes.any,
  getVendorRating: PropTypes.any,
  getVendorRatingSuccess: PropTypes.any,
  getVendorRatingLoading: PropTypes.any,
  enableVendorRatingConfig: PropTypes.any,
  enableVendorRatingConfigLoading: PropTypes.any,
  getUserProfile: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorRatingConfig));
